// extracted by mini-css-extract-plugin
export const flexibleContentContainer = "base-module--flexibleContentContainer--vtfYD";
export const wrapper = "base-module--wrapper--vfBjo";
export const container = "base-module--container--26zyd";
export const bypassLink = "base-module--bypassLink--3rXKA";